import { createApi } from '@reduxjs/toolkit/query/react'
import { ASSIGN_APPRENTICE, CHATTER_PEER_SHARE_EVALUATION, EVALUATE_PEER, UNASSIGN_APPRENTICE } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const apprenticeApi = createApi({
    reducerPath: 'apprenticeApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client",
    }),
    tagTypes: [],
    endpoints: (builder) => ({

        // chatter client details
        assignApprentice: builder.mutation({
            query: ({ caseloadId, apprentice, currentApprenticeId }) => ({
                method: "PUT",
                url: `${ASSIGN_APPRENTICE}/${caseloadId}/${apprentice}/${currentApprenticeId}`
            })
        }),

        // chatter client details
        deleteApprentice: builder.mutation({
            query: ({ caseloadId, currentApprenticeId }) => ({
                method: "PUT",
                url: `${UNASSIGN_APPRENTICE}/${caseloadId}/${currentApprenticeId}`
            })
        }),

        // chatter client evaluate
        evaluatePeer: builder.mutation({
            query: ({ programId, peerId, data }) => ({
                method: "POST",
                url: `${EVALUATE_PEER}/${programId}/${peerId}`,
                data
            })
        }),

        // clients list lookup
        getClientsListLookup: builder.query({
            query: ({ type, data }) => ({
                method: "PATCH",
                url: `/${type}/list`,
                data
            })
        }),

        shareEvaluation: builder.mutation({
            query: ({ programId, peerId, therapistHead, sessionDate }) => ({
                method: "GET",
                url: `${CHATTER_PEER_SHARE_EVALUATION}/${programId}/${peerId}/${therapistHead}/${sessionDate}`,
            })
        }),
    })
})

export const {
    useAssignApprenticeMutation,
    useEvaluatePeerMutation,
    useLazyGetClientsListLookupQuery,
    useShareEvaluationMutation,
    useDeleteApprenticeMutation

} = apprenticeApi;